import { router } from "umi";
import { publicRoutes } from "@/layouts/constants";
import routes from "../../config/routes";
import { GUID_REGEX } from "./constants";
export function getFirstAccessibleRoute(remainingRoutesParam, configPerm) {
    const remainingRoutes = [...remainingRoutesParam]; // This is needed after the second log out / log in because the reference remains the same (with deleted routes because of the shift array method)
    while (remainingRoutes.length > 0) {
        const route = remainingRoutes.shift();
        if (route === undefined ||
            route.path === undefined ||
            route.authority === false ||
            (route.hideInMenu && route.path !== "/fallback")) {
            continue;
        }
        if (Array.isArray(route.routes)) {
            const shouldDeepIn = typeof route.authority === "undefined" ||
                (typeof route.authority === "boolean" && route.authority) ||
                (Array.isArray(route.authority) && route.authority.some(permissionRequired => configPerm[permissionRequired]));
            if (shouldDeepIn) {
                const resp = getFirstAccessibleRoute(route.routes, configPerm);
                if (resp !== null) {
                    return resp;
                }
            }
        }
        if (route.cannotRedirectTo) {
            continue;
        }
        if (route.authority === true || route.authority === undefined) {
            return route.path;
        }
        if (Array.isArray(route.authority)) {
            const matchingPermission = route.authority.find(permissionRequired => configPerm[permissionRequired]);
            if (matchingPermission) {
                if (route.routes) {
                    if (Array.isArray(route.routes)) {
                        const resp = getFirstAccessibleRoute(route.routes, configPerm);
                        if (resp !== null) {
                            return resp;
                        }
                    }
                }
                else {
                    return route.path;
                }
            }
        }
    }
    return null;
}
export function getRouteByPath(pathParam) {
    const path = pathParam.split("?")[0];
    let remainingRoutes = [...routes];
    while (remainingRoutes.length > 0) {
        const route = remainingRoutes.shift();
        if (route === undefined) {
            continue;
        }
        if (route.path === path) {
            return route;
        }
        if (Array.isArray(route.routes)) {
            remainingRoutes = remainingRoutes.concat(route.routes);
        }
    }
    return null; // this path was not found in the routes
}
export function hasAccessToRoute(path, configPerm) {
    const route = getRouteByPath(path);
    if (route === null) {
        return null;
    }
    if (route.authority === true || route.authority === undefined) {
        return true;
    }
    if (Array.isArray(route.authority)) {
        return route.authority.some(permissionRequired => configPerm[permissionRequired]);
    }
    return false;
}
export function pathnameEndsWithGuid(pathname) {
    const lastSegment = pathname.split("/").pop();
    return typeof lastSegment === "string" && GUID_REGEX.test(lastSegment);
}
export function isRouteNavigable(path) {
    const route = getRouteByPath(path);
    if (route === null) {
        return false;
    }
    // A route is navigable if it has a component or redirect
    // Routes with only nested routes (menu containers) are not navigable
    return !!(route.component || route.redirect) || !route.routes;
}
export function redirectToLogin(withRedirectTo = true) {
    if (!withRedirectTo) {
        router.push("/user/login");
        return;
    }
    let path = decodeURIComponent(window.location.pathname);
    let queryParams = window.location.search || path.split("?")[1]; // if pathname has encoded params they can appear in the path instead the query params
    if (queryParams && queryParams.length > 0 && queryParams.startsWith("?")) {
        queryParams = queryParams.slice(1);
    }
    queryParams = queryParams ? decodeURIComponent(queryParams) : "";
    if (path.includes("?")) {
        [path] = path.split("?");
    }
    if (queryParams.includes("returnUrl") || publicRoutes.includes(path)) {
        router.push(`/user/login${queryParams ? `?${encodeURIComponent(queryParams)}` : ""}`);
        return;
    }
    const route = getRouteByPath(path);
    if (!route || (route && (route.cannotRedirectTo || route.public))) {
        router.push(`/user/login${queryParams ? `?${encodeURIComponent(queryParams)}` : ""}`);
        return;
    }
    const returnUrl = encodeURIComponent(`${path}${queryParams ? `?${queryParams}` : ""}`);
    router.push(`/user/login?returnUrl=${returnUrl}`);
}
export function isRedirectSafe(redirectUrl, configPerm) {
    // check if redirectUrl domain is the same as the current domain
    // first we need to check if the redirectUrl is a valid url
    try {
        const urlDefinedDestinationDomain = new URL(redirectUrl).hostname;
        // indeed it is a valid url
        if (urlDefinedDestinationDomain !== window.location.hostname) {
            // it's an external url, it's not safe to redirect to it
            return false;
        }
    }
    catch (error) {
        // it's not a full url
    }
    if (configPerm) {
        const hasAccess = hasAccessToRoute(redirectUrl, configPerm);
        if (hasAccess) {
            return true;
        }
    }
    return publicRoutes.includes(redirectUrl.split("?")[0]);
}
